/* eslint-disable class-methods-use-this */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import RadioGroup from '../../../../common/form/elements/required-radio-group';
import DatePicker from '../../../../common/form/elements/required-datepicker';

const PUSH_NOW = 'now';
const PUSH_LATER = 'later';

const radios = [
  {
    label: 'Push now',
    value: PUSH_NOW,
  },
  {
    label: 'Push Later',
    value: PUSH_LATER,
  }
];

class PushNotificationTiming extends Component {
  render() {
    const {pushWhen, formModel} = this.props;

    return (
      <div>
        <RadioGroup
          model=".push_when"
          radios={radios}
          inline
          onChange={this.handleChange}
        />
        {pushWhen === PUSH_LATER && (
          <DatePicker
            model={`${formModel}.push_at`}
            label="Push at"
            placeholder="Please select a time to push"
            timeFormat="HH:mm"
            future
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  pushWhen: state.deep.push_notification_template.push_when
});

export default connect(mapStateToProps)(PushNotificationTiming);



// WEBPACK FOOTER //
// ./src/components/admin/app/push-notifications/templates/push-notification-timing.jsx